export default __webpack_public_path__ + "static/media/safe7-intro-ar.162e0e85.png";